import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../constants';
import { TopUpPackage } from '../types/common';

interface RechargesProps {
  packages: TopUpPackage[];
  onPackageSelect: (selectedPackage: TopUpPackage) => void;
}

function Recharges({ packages, onPackageSelect }: RechargesProps) {
  const navigate = useNavigate();

  const onSelect = (selectedPackage: TopUpPackage) => {
    onPackageSelect(selectedPackage);
    navigate(ROUTES.PAY_WITH_CARD);
  };

  return (
    <>
      <h2 className="step-title">
        <span>2</span> Selecciona un paquete
      </h2>
      <div className="top-up-package d-flex justify-content-center align-items-center flex-wrap mt-5">
        {packages.map((item) => (
          <div key={item.id} className="top-up-item text-center">
            <h3>{item.title}</h3>
            <hr />
            <div className="top-up-promo-sm">
              <h4 className="gb-promo">{item.headline}</h4>
              <span>+</span>
              <h4 className="calls-promo">
                {item.minutes}
                <br />
                llamadas
              </h4>
              <span>+</span>
              <h4 className="sms-promo">{item.sms}</h4>
            </div>
            <p className="mt-2">Por solo</p>
            <p className="price-top-up">
              <span>$</span>
              {item.price}
            </p>
            <button type="button" className="btn-top-up mt-2" onClick={() => onSelect(item)}>
              ¡Lo quiero!
            </button>
          </div>
        ))}
      </div>
    </>
  );
}

export default Recharges;
